import React from 'react'

export default function EmptyState({ title, message }) {
  return (
    <div className="border rounded p-4 text-center text-sm text-gray-600">
      <div className="font-semibold text-gray-800 mb-1">{title}</div>
      <div>{message}</div>
    </div>
  )
}
